import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';
import { Appointment } from './appointment.js';
import { Workshop } from './workshop.js';

@Entity()
export class WorkshopAppointmentParticipationConfirmationLink extends AdornisEntity {
  static override _class = 'WorkshopAppointmentParticipationConfirmationLink';

  @validate(nonOptional())
  @Field(type => String)
  workshopID!: string;

  @validate(nonOptional())
  @Field(type => String)
  appointmentID!: string;

  @Field(type => Appointment, {
    resolve: function (this: WorkshopAppointmentParticipationConfirmationLink) {
      return async (gqlFields: BaseQLSelectionSet<Appointment>) => {
        const workshop = await getByID(Workshop, this.workshopID)({ appointments: gqlFields });
        return workshop?.appointments?.find(ap => ap._id === this.appointmentID) as any;
      };
    },
  })
  appointment!: Appointment;

  @validate(nonOptional())
  @Field(type => DateTime, { default: v => v ?? DateTime.now() })
  validFrom: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(type => DateTime)
  validTill: Maybe<DateTime>;

  @validate(nonOptional())
  @Field(type => String)
  url!: string;
}
